<template>	
	<div class="page" data-name="payment-final-list">
		<div class="page-content" style="background-color:#efeff4">			
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">최종 결제</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
				</f7-nav-right>
			</f7-navbar>			
			<div class="block-title" v-if="onlyOnlineCheck == false">주소지 정보</div>
			<div class="card card-outline" v-if="onlyOnlineCheck == false">
				<div class="card-content card-content-padding">
					<div class="list">
						<ul>
							<li class="item-content item-input item-input-outline">      
								<div class="item-inner">
									<div class="item-title item-floating-label ">이름</div>
									<div class="item-input-wrap ">
										<input type="text" name="userName" id="userName" ref="userName">
										<span class="input-clear-button"></span>
									</div>						
								</div>
							</li>
							<li class="item-content item-input item-input-outline row">      
								<div class="col-60">
									<div class="item-inner">								
										<div class="item-input-wrap">
											<input type="text" name="post" ref="postNo" readonly placeholder="우편번호">									
										</div>
									</div>
								</div>
								<div class="col-40">
									<div class="item-inner">				
										<button class="button button-outline"  v-on:click="openPostPopup">검색</button>					
									</div>
								</div>
							</li>
							<li class="item-content item-input item-input-outline" ref="postAddr" style="display:none">							
								<div class="row">
									<div class="left"></div>
									<div class="right" style="padding-right:5px;"><button class="button" style="padding-top:5px" v-on:click="closePostPopup"><i class="f7-icons">clear</i></button></div>	
								</div>
								<div class="item-inner">							
									<div class="item-input-wrap">			  					
										<div id='postcode' ref="postCode" style="width:'100%';height:'500px'" />       					
									</div>
								</div>
							</li>  
							<li class="item-content item-input item-input-outline">      
								<div class="item-inner">							
									<div class="item-input-wrap">
										<input type="text" name="address" ref="address" readonly placeholder="주소">								
									</div>
								</div>
							</li>
							<li class="item-content item-input item-input-outline">      
								<div class="item-inner">
									<div class="item-title item-floating-label">상세주소</div>
									<div class="item-input-wrap">
										<input type="text" name="subAddress" ref="subAddress">
										<span class="input-clear-button"></span>
									</div>
								</div>
							</li>
							<li class="item-content item-input item-input-outline row">      
								<div class="item-inner">
									<div class="item-title item-floating-label">휴대폰번호 및 연락처 입력</div>
									<div class="item-input-wrap">
										<input type="tel" name="mobile" ref="mobile" v-on:keyup="keyPress($event,'MOBILE')"  :maxlength="phoneMax">
										<span class="input-clear-button"></span>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>	
			<div class="block-title">상품 정보</div>
			<div class="card card-outline">
				<div class="card-content card-content-padding">
					<div class="list media-list">
						<ul>
							<template v-for="(item,i) in paymentList">
								<li :key="'ii' + i" class="item-content">
									<div class="item-media">
										<img :src="productImageUrl(i)" width="143" height="70"/>
									</div>
									<div class="item-inner">
										<div class="item-title-row">
											<div class="item-title">												
											 	{{item.PRODUCT_NAME}}													 
												<i class="f7-icons "  style="vertical-align: text-bottom;cursor:pointer" v-on:click="deleteProduct(i)">multiply_square_fill</i>
											</div>
										</div>
										<div class="item-subtitle">
											{{item.USER_NAME}} 학생 /
											{{getPrice(item.ORIGINAL_PRICE-item.DISCOUNT_PRICE)}}원
										</div>
									</div>
								</li>
							</template>
						</ul>
					</div>
				</div>
			</div>


			<div class="block-title">최종 결제정보 ({{paymentList.length}}개)</div>
			<div class="card card-outline">
				<div class="card-content card-content-padding">
					<div class="list no-hairlines-between">
						<ul>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">상품금액 :</div>
										<div class="item-after"><b>{{getPrice(productsPrice)}} 원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">할인금액 :</div>
										<div class="item-after"><b style="color:#ff0000">-{{getPrice(discountPrice)}} 원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">배송비 :</div>
										<div class="item-after"><b>+{{getPrice(shipPrice)}}원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">결제금액 :</div>
										<div class="item-after">
											<h4 class="margin-right" v-if="(productsPrice+shipPrice) > orderPrice">
												<s>{{getPrice(productsPrice+shipPrice)}}원</s>
											</h4>
											<h3><b style="color:#00aaff">{{getPrice(orderPrice)}}원</b></h3>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="block-title">결제수단</div>
			<div class="card card-outline">
				<div class="card-content card-content-padding">
					<div class="list media-list">
						<ul>
							<li>
								<label class="item-radio item-content">
								<input type="radio" name="radio-ini-payment" value="CARD" v-model="iniPayment"/>
								<i class="icon icon-radio"></i>
								<div class="item-inner">
									<div class="item-title">신용카드</div>
								</div>
								</label>
							</li>
							<li>
								<label class="item-radio item-content">
								<input type="radio" name="radio-ini-payment" value="MOBILE" v-model="iniPayment"/>
								<i class="icon icon-radio"></i>
								<div class="item-inner">
									<div class="item-title">휴대폰</div>
								</div>
								</label>
							</li>						
							<li>
								<label class="item-radio item-content">
								<input type="radio" name="radio-ini-payment" value="VBANK" v-model="iniPayment"/>
								<i class="icon icon-radio"></i>
								<div class="item-inner">
									<div class="item-title">가상계좌</div>
								</div>
								</label>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="block">
				<div class="item-inner">				
					<button class="button button-fill " ref="payment" v-on:click="finalPayment()">결제하기</button>				
				</div>				
			</div>
		</div>
		<!--INI PAY 결제 -->
		<div class="popup inipay-view-popup" id="inipay-view-popup" >
			<div class="view">
				<div class="page">
					<div class="navbar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner">
							<div class="title">결제</div>
							<div class="right">								
								<a class="link popup-close">닫기</a>
							</div>
						</div>
					</div>
					<div class="page-content inipay-content" style="overflow-x:hidden;overflow-y:hidden;">	
						<div style="width:100%;height:100%;" ref="tempDiv">
						
						</div>
					</div>
				</div>
			</div>
		</div>
		<form method="post" id="paymentMobileForm" name="paymentMobileForm" ref="paymentMobileForm" accept-charset="euc-kr" > <!-- 모바일용 결제 폼-->
			<input type="hidden" name="P_CHARSET" ref="P_CHARSET" /> <!--캐릭터셋 설정-->		
			<input type="hidden" name="P_INI_PAYMENT" ref="P_INI_PAYMENT" /> <!--결제 종류 ex:)신용카드,계좌이체-->
			<input type="hidden" name="P_HPP_METHOD" ref="P_HPP_METHOD" /> <!--휴대폰 결제시 필요-->
			<input type="hidden" name="P_MID" ref="P_MID" /> <!--발급받은 상점 ID-->
			<input type="hidden" name="P_GOODS" ref="P_GOODS" /> <!--상품명-->
			<input type="hidden" name="P_OID" ref="P_OID" /> <!--상점주문번호-->
			<input type="hidden" name="P_AMT" ref="P_AMT" /> <!--결제금액(숫지만, 콤마(",") 사용불가)-->
			<input type="hidden" name="P_UNAME" ref="P_UNAME" /> <!--구매자 이름-->
			<input type="hidden" name="P_MOBILE" ref="P_MOBILE" /> <!--구매자 휴대폰-->
			<input type="hidden" name="P_EMAIL" ref="P_EMAIL" /> <!--구매자 이메일 주소-->
			<input type="hidden" name="P_NEXT_URL" ref="P_NEXT_URL" /> <!--인증결과 수신 URL-->
			<input type="hidden" name="P_NOTI" ref="P_NOTI" /> <!--가맹점 정보필드-->
			<input type="hidden" name="P_NOTI_URL" ref="P_NOTI_URL" /> <!--승인결과통보 Url-->				
		</form>

		<form id="paymentWebForm" name="paymentWebForm" ref="paymentWebForm" method="post" > <!-- WEB용 결제 폼-->
			<input type="hidden" name="version" ref="version" /> <!-- 전문 버전 (1.0)  고정-->
			<input type="hidden" name="gopaymethod" ref="gopaymethod" /> <!--요청결제수단 (빈값으로 세팅 시, 전체 결제수단 표시) -->
			<input type="hidden" name="mid" ref="mid" /> <!--발급받은 상점 MID-->
			<input type="hidden" name="oid" ref="oid" /> <!--주문번호 -->
			<input type="hidden" name="goodname" ref="goodname" /> <!-- 상품명 (40Byte 초과 요청시 37Byte + ...으로 자동 변환) -->
			<input type="hidden" name="price" ref="price" /> <!--결제금액 (숫자만, 1달러는 100으로 시작) -->
			<input type="hidden" name="timestamp" ref="timestamp" /> <!--타임스템프 (TimeInMillis(Long형)) -->
			<input type="hidden" name="signature" ref="signature" /> <!--SHA256 Hash값 (oid, price, timestamp)-->
			<input type="hidden" name="mKey" ref="mKey" /> <!-- 가맹점에 제공된 웹 표준 signKey를 해시값으로 변경 (SHA-256방식 사용) -->
			<input type="hidden" name="returnUrl" ref="returnUrl" /> <!--리턴 URL  -->
			<input type="hidden" name="closeUrl" ref="closeUrl" /> <!-- 결제창 닫기 URL -->
			<input type="hidden" name="popupUrl" ref="popupUrl" /> <!-- 팝업처리 URL -->
			<input type="hidden" name="currency" ref="currency" /> <!-- 통화구분 (WON:한화,USD:달러 [USD는 카드 결제만 가능])  -->
			<input type="hidden" name="buyername" ref="buyername" /> <!-- 구매자명 (30Byte 초과 요청시 30Byte로 자동 변환) -->
			<input type="hidden" name="buyertel" ref="buyertel" /> <!-- 구매자 휴대폰번호 (숫자와 "-" 만 허용) -->
			<input type="hidden" name="buyeremail" ref="buyeremail" /> <!-- 구매자 Email ("@", "." 외 특수문자 입력불가) -->
			<input type="hidden" name="payViewType" ref="payViewType" /> <!--결제창 표시 방법 [overlay,popup]  Default: overlay -->
			<input type="hidden" name="charset" ref="charset" /><!-- 	결과 수신 인코딩 [UTF-8,EUC-KR]  Default: UTF-8 -->
			<input type="hidden" name="merchantData" ref="merchantData" /> <!--가맹점 임의 데이터 (인증결과 시 수신)  * 한글 입력불가, 한글입력은 urlencode 필수 -->		
		</form>

	</div>
</template>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
	data() {
		return {
			paymentList: [],		
			addrType: "company",
			phoneMax: 13,	
			orderPrice: 0,
			shipPrice: 0,			
			productsPrice: 0,
			discountPrice: 0,
			iniPayment: "CARD", //디폴트 card 지불
			shipType: "prepaid",	
			onlyOnlineCheck: true,
			orderKey: 0,
			orderId: "",	
			signature: "",
			timeStamp: "",
			mKey: "",
			iniPayMid: "",//inicis 상점 ID
			iniPaySignKey: ""//inicis WEB용 인증키

		}	
	},
	mounted() {
		const _this = this;
		_this.orderKey = _this.$f7route.context.orderKey;

		if(_this.orderKey > 0) {
			_this.getOrderInfo();
		}else {
			_this.paymentList = _this.$f7route.context.paymentList;		
			_this.addrType = _this.$f7route.context.radioAddrType;		
			_this.calcPayment(true);
		}


		if(document.pwaIniPayResult == undefined) {
			document.iniPayResult = function(code, data) {
				_this.setIniPayResult(code, data);
			}
		}		
		
	},
	methods: {
		
		setIniPayResult(resultCode, jsonData) {
			const _this = this;			
			var resultData = MODULE.Util.JsonStrToObject(jsonData);

			_this.$f7.popup.close("#inipay-view-popup", true);	
			$(_this.$refs.tempDiv).html("");
			
			if (resultCode == CONST.resultCode.OK) {
				MODULE.DialogBox.message("결제완료 되었습니다.");
				PAGES.goPage(PAGES.MENU_PAYMENT_RESULT_LIST);
			} else if (resultCode == CONST.resultCode.FAIL) {
				MODULE.DialogBox.message(resultData.resultMessage);
			} else {
				MODULE.DialogBox.message("서버에 오류가 발생하였습니다.");
			}  
  	
		},
		getOrderInfo() {
			const _this = this;

			let param = {
				pOrderKey : _this.orderKey
			}
			
			API.ajaxRequest({
				url: API.getOrderInfoUrl(),
				data: param
			}).then(function (data) {				
				_this.paymentList = data.paymentList;				
				_this.calcPayment(false);
				
				if(!_this.onlyOnlineCheck){
					_this.$utils.nextTick(function() {
						_this.setAddressInfo(data.shipInfo);
					});					
				}
							
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
			

		},
		finalPayment() {
			const _this = this;

			var orderUserName = "-";
			var shipPostCode = "-";
			var addr = "-";
			var subAddr = "-";		
			var shipMobile = "-";
			var shipAddr = "-";			
			
			if(!_this.onlyOnlineCheck) {

				orderUserName = _this.$refs.userName.value;

				if(MODULE.Util.isEmpty(orderUserName)){
					MODULE.DialogBox.message("이름을 입력하세요.");
					return;
				}

				shipPostCode = _this.$refs.postNo.value;

				if(MODULE.Util.isEmpty(orderUserName)){
					MODULE.DialogBox.message("우편번로를 입력하세요.");
					return;
				}
				
				addr = _this.$refs.address.value;
				
				if(MODULE.Util.isEmpty(addr)){
					MODULE.DialogBox.message("주소를 입력하세요.");
					return;
				}		

				subAddr = _this.$refs.subAddress.value;

				if(MODULE.Util.isEmpty(subAddr)){
					MODULE.DialogBox.message("상세 주소를 입력하세요.");
					return;
				}	

				shipMobile = _this.$refs.mobile.value;

				if(MODULE.Util.isEmpty(shipMobile)){
					MODULE.DialogBox.message("휴대폰 번호 및 연락처를 입력하세요.");
					return;
				}	

				shipAddr = addr +"."+ subAddr;
			}

			if(_this.paymentList.length == 0) {
				MODULE.DialogBox.message("선택된 상품이 없습니다.");
				return;
			}
						
			var orderProdcutList = [];

			for(var i = 0; i < _this.paymentList.length; i++) {
				var item = _this.paymentList[i];
				
				var obj = _this.getOrderProductObj();
				obj.buyCnt = item.BUY_CNT;
				obj.studentKey = item.STUDENT_KEY;
				obj.studentName = item.USER_NAME;
				obj.productPrice = item.ORIGINAL_PRICE;
				obj.productKey = item.PRODUCT_KEY;				
				orderProdcutList.push(obj);			
			}

			var payType;
			if(MODULE.Util.isMobileBrowser()){
				payType = "mobile";
			} else {
				payType = "web";
			}

			let requestInfo = {
				orderKey			: _this.orderKey,
				orderPrice 		: _this.orderPrice,
				productsPrice	: _this.productsPrice,
				shipPrice			: _this.shipPrice,
				shipType			: _this.shipType,
				shipAddr 			: shipAddr,
				shipPostCode  : shipPostCode,
				shipMobile 		: shipMobile,
				payType				: payType,				
				orderProdcutList : orderProdcutList
			}
			
			API.jsonRequest({
				url: API.setPaymentInfoUrl(),
				data: requestInfo
			}).then(function (data) {			
				_this.orderKey = data.orderKey;
				_this.orderId = data.orderId;
				_this.timeStamp = data.timeStamp;
				_this.mKey = data.mKey;
				_this.iniPayMid = data.iniPayMid;
				_this.signature = data.signature;
				_this.$utils.nextTick(function() {

					if(MODULE.Util.isMobileBrowser()){
						_this.openMobileIniPay();				
					} else {
						_this.openWebIniPay();
					}
					
				});				
			}).catch(function(code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});

		},
		getOrderProductObj() {

			var orderProductObj = {
				buyCnt: 0,
				studentKey: 0,
				studentName: "",
				productPrice: 0,
				productKey: 0  
			};

			return orderProductObj
		},
		openWebIniPay() {
			const _this = this;
			var orderName = "";

			if(_this.paymentList.length > 1) {
				var item = _this.paymentList[0];
				orderName  = item.PRODUCT_NAME+" 외 "+_this.paymentList.length-1+"건";
			}else  {
				var item = _this.paymentList[0];
				orderName = item.PRODUCT_NAME;
			}

			_this.$refs.version.value = "1.0";

			var gopaymethod = ""; 

			if(_this.iniPayment == "CARD") {
				gopaymethod = "Card";
			} else if(_this.iniPayment == "MOBILE") {
				gopaymethod = "HPP";
			} else {
				gopaymethod = "VBank";
			}
			const userInfo = AUTH.getUserInfo();
			_this.$refs.gopaymethod.value = gopaymethod;
			_this.$refs.mid.value = _this.iniPayMid;  	
			_this.$refs.oid.value = _this.orderId;
			_this.$refs.goodname.value = orderName;
			_this.$refs.price.value = _this.orderPrice;
			_this.$refs.timestamp.value = _this.timeStamp;
			_this.$refs.signature.value = _this.signature;
			_this.$refs.mKey.value = _this.mKey;
			_this.$refs.returnUrl.value = API.getIniPayWebCertResultUrl();
			//_this.$refs.closeUrl.value = API.iniPayWebCloseUrl();			
			_this.$refs.closeUrl.value ="";
			_this.$refs.popupUrl.value = API.iniPayWebPopUpUrl();
			_this.$refs.currency.value = "WON";

			if(_this.orderUserName == undefined || _this.orderUserName == "") {
				_this.orderUserName = userInfo.USER_NAME;
			}

			_this.$refs.buyername.value = _this.orderUserName;
			_this.$refs.buyertel.value = userInfo.USER_ID; // 학부모는 아이디가 핸드폰번호임 이후 다른케이스 생기면 폰 번호 가져오는거 생각해야함
			_this.$refs.buyeremail.value = "";
			_this.$refs.payViewType.value = "popup";
			_this.$refs.charset.value = "UTF-8";
			_this.$refs.merchantData.value = _this.orderId;		
			_this.iniPayScrtipMount();								
		},
		openMobileIniPay(){
			const _this = this;
			var orderName = "";

			if(_this.paymentList.length > 1) {
				var item = _this.paymentList[0];
				orderName  = item.PRODUCT_NAME+" 외 "+_this.paymentList.length-1+"건";
			}else  {
				var item = _this.paymentList[0];
				orderName = item.PRODUCT_NAME;
			}

			/*
			$(_this.$refs.tempDiv).html("");
			_this.$f7.popup.open("#inipay-view-popup", true);	
		
			var iframe = "<iframe src='about:blank'  width='100%' height='100%' scrolling='yes' name='iframePayment' ref='iframePayment'></iframe>";
			$(_this.$refs.tempDiv).html(iframe);
			*/
			window.name="IniPayPopup";
			var IniPayWindow;
			var UserAgent = navigator.userAgent;
			IniPayWindow = window.open('', 'IniPayWindow', 'width=460, height=570, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );

			if(IniPayWindow == null){
				var message = "브라우저의 팝업이 허용되어 있는지 확인해 주세요.";					
				MODULE.DialogBox.message(message);
				return;
			}
			
			_this.$refs.P_INI_PAYMENT.value = _this.iniPayment;
			if(_this.iniPayment == "MOBILE") {
				if(_this.onlyOnlineCheck) {
					_this.$refs.P_HPP_METHOD.value = "1"; //무형
				}else{
					_this.$refs.P_HPP_METHOD.value = "2"; // 유형
				}
			}

			_this.$refs.P_MID.value = _this.iniPayMid;  			
			_this.$refs.P_CHARSET.value = "utf8";
			_this.$refs.P_GOODS.value = orderName;     
			_this.$refs.P_OID.value = _this.orderId;
			_this.$refs.P_AMT.value = _this.orderPrice;	
			const userInfo = AUTH.getUserInfo();
			if(_this.orderUserName == undefined || _this.orderUserName == "") {
				_this.orderUserName = userInfo.USER_NAME;
			}					

			_this.$refs.P_UNAME.value = _this.orderUserName;  
			_this.$refs.P_MOBILE.value = "";
			_this.$refs.P_EMAIL.value = "";			
			_this.$refs.P_NEXT_URL.value = API.getIniPayMobileCertResultUrl()+"?P_ORDER_ID="+_this.orderId
			_this.$refs.P_NOTI.value = "";
			_this.$refs.P_NOTI_URL.vlaue = API.getIniPayNotiResultUrl(); //가상계좌시 필요
			_this.$refs.paymentMobileForm.action = CONST.iniPayMobileServerUrl+CONST.iniPayMethod[_this.iniPayment].url;
			//_this.$refs.paymentMobileForm.target = "iframePayment";			
			_this.$refs.paymentMobileForm.target = "IniPayWindow";			
			_this.$refs.paymentMobileForm.submit();  		
			
		},
		calcPayment(bAddressInfo) {
			const _this = this;
			var itemPrice = 0;
			var itemDiscountPrice = 0;
			var itemShipPrice = 0;
			var itemShipPriceCheck = false;			

			for(var i = 0; i < _this.paymentList.length; i++) {
				var item = _this.paymentList[i];

				itemPrice += item.ORIGINAL_PRICE;
				itemDiscountPrice += item.DISCOUNT_PRICE;

				if(!itemShipPriceCheck && 
					CONST.productType[item.PRODUCT_TYPE].shipPrice > 0) { // 배송비가 붙은 제품이면 
					itemShipPriceCheck = true;					
				}

				if(CONST.productType[item.PRODUCT_TYPE].id != "online") {
					_this.onlyOnlineCheck = false;
				}
			}

			_this.productsPrice = itemPrice;
			_this.discountPrice = itemDiscountPrice;
			
			if(itemShipPriceCheck && (_this.productsPrice < 25000)) { // 현재 강아 기준 상품 금액 이하면 배송비 붙음
				_this.shipPrice = 4000;
				//조건에 따라 선불 및 후불 배송 타입 결정 지금은 선불 배송비로 fix
				_this.shipType = "prepaid";
			}else {
				_this.shipType = "freeship";
			}

			_this.orderPrice = _this.productsPrice - _this.discountPrice + _this.shipPrice;

			if(!_this.onlyOnlineCheck && bAddressInfo == true) { // 온라인만 있는 결제가 아니라면 배송정보 가져오기
				_this.getAddress();
			}

		},
		getAddress(){
			const _this = this;

			let param  = {
				pAddrType : _this.addrType,				
			}

			API.ajaxRequest({
				url: API.getPaymentAddrUrl(),
				data: param
			}).then(function (data) {
				_this.setAddressInfo(data);			
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
			
			
		},
		setAddressInfo(info) {

			try {
				const _this = this;
				
				var address = info.SHIP_ADDR.split(".");     				
				_this.setElement(_this.$refs.userName, info.ORDER_USER_NAME);
				_this.setElement(_this.$refs.mobile, info.SHIP_MOBILE);

				if(_this.orderKey) {
					_this.setElement(_this.$refs.postNo, info.SHIP_POSTCODE);
					_this.setElement(_this.$refs.address, address[0]);
					_this.setElement(_this.$refs.subAddress, address[1]);
				}else {
					_this.setElement(_this.$refs.postNo, address[0]);
					_this.setElement(_this.$refs.address, address[1]);
					_this.setElement(_this.$refs.subAddress, address[2]);
				}
				

			}catch(e) {
  
			}
		},
		setElement(element,value){
			var el = $(element);
			el.val(value);
			el.addClass("input-with-value");
			el.parents("li").addClass("item-input-with-value");
		},
		deleteProduct(itemIndex) {
			const _this = this;
			
			if(_this.paymentList.length == 1){
				MODULE.DialogBox.message("상품 1개 이상은 등록 되셔야합니다.");	
				return;
			}

			MODULE.DialogBox.okcancel(
				"확인",	"해당 주문 상품을 제외 하시겠습니까?",			
				function() {
					_this.paymentList.splice(itemIndex, 1);				
					_this.calcPayment(false);
				}
			);
		},
		getPrice(price) {
			const _this = this;
			var won = MODULE.Util.autoMakeComma(price);
			return won;
		},
		productImageUrl(itemIndex) {
			const _this = this;
			var item = _this.paymentList[itemIndex];
			var imgPath = MODULE.Util.getProductImgUrl(item.PRODUCT_KEY);									

			return imgPath;			
		},
		iniPayScrtipMount(){
			const _this = this;
			const scriptId = 'ini_pay_script';
			const isExist = !!document.getElementById(scriptId);

			if (!isExist) {
				const script = document.createElement('script');
				script.src = CONST.iniPayWebServerUrl+"/stdjs/INIStdPay.js";
				script.onload = () => INIStdPay.pay('paymentWebForm');			
				script.id = scriptId;
				document.body.appendChild(script);
			} else {
				INIStdPay.pay('paymentWebForm');
			} 
		},
		postCodeMount(){			
			const _this = this;
			const scriptId = 'daum_postcode_script';
			const isExist = !!document.getElementById(scriptId);
		
			if (!isExist) {
				const script = document.createElement('script');
				script.src = CONST.daumMapServerUrl+"/dmaps/map_js_init/postcode.v2.js?autoload=false";
				script.onload = () => _this.postCodeInitiate(this);
				script.onerror = error => _this.handleError(error);
				script.id = scriptId;
				document.body.appendChild(script);
			} else {
				_this.postCodeInitiate(this);
			} 
			
		},
		postCodeInitiate(){		
			const _this = this;
			window.daum.postcode.load(() => {
				new window.daum.Postcode({
					oncomplete: function oncomplete (data) {
						if (data.postcode1) {
							_this.$refs.postNo.value = data.postcode;
						}else{
							_this.$refs.postNo.value = data.zonecode;
						}
						if (data.userSelectedType == "R") {
							_this.$refs.address.value = data.roadAddress;							
						}else{
							_this.$refs.address.value = data.jibunAddress;							
						}
						
						_this.$refs.postAddr.style.display="none";
					},
					onresize: function onresize (size) {              
					},          
					autoMapping: false,
					autoResize: true,
					hideEngBtn: false,
					hideMapBtn: false,						
					width: '100%',
					height: '400px'
				}).embed(_this.$refs.postCode, { q: null, autoClose: true })
			});
		},
		keyPress(event,type){
			const _this = this;

			if(type == "MOBILE"){
				const element = event.currentTarget;					
				element.value = MODULE.Util.autoHypenMobile(element.value);
			}
		},
		openPostPopup(event){
			const _this = this;
			_this.$refs.postAddr.style.display="block";
			_this.postCodeMount();
		},
		closePostPopup(event){
			const _this = this;
			_this.$refs.postAddr.style.display="none";
		}
	}
}
</script>